export default {"src":"/_next/static/media/telegram-icon.5a761eb4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};